export const namespaced = true

export const state = {
    message: '',
    color: 'info'
}

export const mutations = {
    SET_MESSAGE (state, message) {
        state.message = message
    },
    SET_COLOR (state, color) {
        state.color = color
    },
    CLEAR_MESSAGE (state) {
        state.message = ''
    }
}

export const actions = {
    showSnackbar({commit}, { message, color = 'info' }) {
        commit('SET_MESSAGE', message)
        commit('SET_COLOR', color)
    },
    dismissSnackbar ({ commit }) {
        commit('CLEAR_MESSAGE')
    },
}

export const getters = {
    hasSnackbar (state) {
        return typeof state.message !== 'undefined' && state.message !== null && state.message.length > 0
    }
}
